export const walk_sv = {
  'has_shared_walk_message' : ' har just delat en promenad med dig!',
  'give_walk_review' : 'Ge promenaden ett omdöme',
  'person_has_booked_walk' : ' har bokat denna promenad',
  'you_cancel_button' : 'Ställ in promenad',
  'other_cancel_button' : 'Avboka promenad',
  'change_walk_button' : 'Ändra promenad',
  'walk_already_booked' : 'Promenaden är redan bokad',
  'book_walk_button' : 'Boka promenad',
  'no_longer_able_question' : 'Kan du inte längre gå promenaden? Klicka nedan för att boka av.',
  'cancel_walk_confirmation' : 'Avboka nu',
  'the_walk_is_booked' : 'Promenaden är bokad',
  'added_to_cal' : 'Tillagd i kalender',
  'invitation' : 'Inbjuden',
  'private' : 'Privat',
  'invited_persons' : 'Inbjudna personer:',

  'private_notes' : 'Privata anteckningar',
  'notes' : 'Anteckningar',
  'card_edited' : 'Kortet redigeras...',
  'add_agenda' : 'lägg till punkt',
  'add_subject' : 'lägg till ämne',
  'add_private' : 'lägg till privat',
  'share_notes' : 'Dela anteckningar',
  'send_notes_email' : 'Skicka som email',
  'copy_notes' : 'Kopiera anteckningar',
  'text_copied' : 'Texten är kopierad',
  'note_edit_not_allowed' : 'Du kan inte redigera eller ta bort någon annans anteckning.',
  
  'map' : 'Karta',
  'something_wrong' : 'Något gick fel',
  'log_in_or_create' : 'Logga in eller skapa ett konto för att läsa, skapa och redigera anteckningar.',
  'enter_room' : 'Gå in i mötet',
  'leave_room' : 'Lämna mötet',
  'person_in_meeting' : ' person i mötet',

  'enter_text' : 'Skriv här',
  'share_note' : 'Dela anteckningen',

  'certain_delete' : 'Är du säker på att du vill ta bort anteckningen',
  'edit_agenda' : 'Redigera agendan',
  'edit' : 'Redigera',
  'delete' : 'Ta bort'
}